import auth from "../../middlewares/auth";
export const ordersRoute = [
  {
    path: '/orders',
    component: () => import(/* webpackChunkName: "orders" */ '../../views/orders/OrderList'),
    name: 'orders',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/order/edit/:id',
    component: () => import(/* webpackChunkName: "orders" */ '../../views/orders/OrderForm'),
    name: 'order_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];